var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",attrs:{"action":_vm.action,"method":_vm.method,"target":"_blank"}},[_vm._l((_vm.fields),function(value,key){return _c('input',{key:key,attrs:{"type":"hidden","name":key},domProps:{"value":value}})}),_c('input',{attrs:{"type":"hidden","name":"accessToken"},domProps:{"value":_vm.token}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }